<template>
  <router-view />
  <FeatureTourOverlay />
  <PwaInstallPrompt />
  <AppConfirmHost />
</template>

<script setup lang="ts">
import AppConfirmHost from '@/components/common/AppConfirmHost.vue'
import FeatureTourOverlay from '@/components/common/FeatureTourOverlay.vue'
import PwaInstallPrompt from '@/components/common/PwaInstallPrompt.vue'
import { useAppBackNavigation } from '@/composables/useAppBackNavigation'
import { usePortraitLock } from '@/composables/usePortraitLock'
import { captureInstallSourceFromUrl } from '@/composables/usePwaInstall'

// 문자 링크 query를 스플래시 전에 세션에 남김
captureInstallSourceFromUrl()

useAppBackNavigation()
usePortraitLock()
</script>
